angular.module('autoremind.dashboard.directives')
    .directive('newsWidget', ['$location', function ($location) {
        return {
            templateUrl: 'app/dashboard/widgets/news/news.html',
            scope: true,
            link: function (scope, elem, attr) {
            }
        };
    }]);
//# sourceMappingURL=news.directive.js.map